(function () {
  var sec = document.querySelector('.pdp');
  if (!sec) return;

  var isCustom = sec.getAttribute('data-custom') === 'true';
  var basePw = parseFloat(sec.getAttribute('data-pw')) || 20;
  var basePh = parseFloat(sec.getAttribute('data-ph')) || 30;

  var frame = document.getElementById('pdpFrame');
  var img = document.getElementById('pdpImg');
  var empty = document.getElementById('pdpEmpty');
  var fileInput = document.getElementById('photoInput');
  var uploadBox = document.getElementById('uploadBox');
  var zoom = document.getElementById('zoom');
  var adjustField = document.getElementById('adjustField');
  var quality = document.getElementById('pdpQuality');
  var qualityText = document.getElementById('qualityText');
  var addBtn = document.getElementById('pdpAdd');
  var meta = document.getElementById('pdpMeta');
  var variantIdInput = document.getElementById('variantId');
  var addPriceEl = document.getElementById('pdpAddPrice');
  var priceEl = document.getElementById('pdpPrice');
  var propOrient = document.getElementById('propOrient');
  var propSize = document.getElementById('propSize');
  var propDpi = document.getElementById('propDpi');
  var propPhotoUrl = document.getElementById('propPhotoUrl');
  var dimNote = document.getElementById('dimNote');
  var cw = document.getElementById('cw');
  var ch = document.getElementById('ch');
  var subEl = document.getElementById('pdpSub');
  var upStatus = document.getElementById('pdpUpStatus');
  var upFill = document.getElementById('pdpUpFill');
  var upText = document.getElementById('pdpUpText');

  var orient = 'portrait';
  var uploaded = false, uploadComplete = false, imgW = 0, imgH = 0, customValid = true;

  function dims() {
    var w = basePw, h = basePh;
    if (isCustom && cw && ch) { w = parseInt(cw.value, 10) || 0; h = parseInt(ch.value, 10) || 0; }
    if (orient === 'landscape') return { w: Math.max(w, h), h: Math.min(w, h) };
    return { w: Math.min(w, h), h: Math.max(w, h) };
  }

  function ratioStr(w, h) { function g(a, b) { return b ? g(b, a % b) : a; } var d = g(w, h) || 1; return (w / d) + ':' + (h / d); }

  function updateSub() {
    if (!subEl) return;
    if (isCustom) { subEl.textContent = 'Custom size \u00b7 made to order'; return; }
    var r = ratioStr(Math.min(basePw, basePh), Math.max(basePw, basePh));
    subEl.textContent = orient.charAt(0).toUpperCase() + orient.slice(1) + ' \u00b7 ' + r + ' ratio';
  }

  function sizePreview() {
    var d = dims();
    var scale = 320 / Math.max(d.w, d.h || 1);
    frame.style.width = (d.w * scale) + 'px';
    frame.style.height = (d.h * scale) + 'px';
    updateMeta();
    updateSub();
    if (uploaded) fitImg();
  }

  function updateMeta() {
    var d = dims();
    meta.textContent = d.w + ' \u00d7 ' + d.h + '" \u00b7 embossed & gallery-wrapped';
    if (propSize) propSize.value = d.w + '\u00d7' + d.h + '"' + (isCustom ? ' (custom)' : '');
    if (propOrient) propOrient.value = orient.charAt(0).toUpperCase() + orient.slice(1);
  }

  function fitImg() {
    if (!uploaded) return;
    var pw = frame.clientWidth, ph = frame.clientHeight;
    var cover = Math.max(pw / imgW, ph / imgH) * parseFloat(zoom.value || 1);
    img.style.width = (imgW * cover) + 'px';
    img.style.height = (imgH * cover) + 'px';
    img.style.transform = 'translate(-50%,-50%)';
  }

  function checkQuality() {
    var d = dims();
    var dpi = Math.round(Math.min(imgW / d.w, imgH / d.h));
    quality.className = 'pdp-quality show';
    if (dpi >= 300) { quality.classList.add('q-good'); qualityText.textContent = 'Excellent quality \u00b7 ~' + dpi + ' DPI'; }
    else if (dpi >= 150) { quality.classList.add('q-ok'); qualityText.textContent = 'Good quality \u00b7 ~' + dpi + ' DPI'; }
    else { quality.classList.add('q-low'); qualityText.textContent = 'Low resolution \u00b7 ~' + dpi + ' DPI \u2014 may look soft.'; }
    if (propDpi) propDpi.value = dpi + ' DPI';
  }

  /* ---- Cloudinary upload ---- */
  function showUp(state, arg) {
    if (!upStatus) return;
    upStatus.style.display = 'block';
    upStatus.className = 'pdp-upstatus ' + state;
    if (state === 'progress') { if (upFill) upFill.style.width = (arg || 0) + '%'; if (upText) upText.textContent = 'Uploading your photo\u2026 ' + (arg || 0) + '%'; }
    else if (state === 'done') { if (upFill) upFill.style.width = '100%'; if (upText) upText.textContent = 'Photo uploaded \u2713'; }
    else { if (upText) upText.textContent = arg || 'Upload failed \u2014 please try again'; }
  }

  function uploadToCloud(file) {
    var cfg = window.PDP_CLOUDINARY || {};
    if (!cfg.cloud || !cfg.preset) { showUp('error', 'Photo upload is not configured yet.'); return; }
    showUp('progress', 0);
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', cfg.preset);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + cfg.cloud + '/auto/upload', true);
    xhr.upload.onprogress = function (e) { if (e.lengthComputable) showUp('progress', Math.round(e.loaded / e.total * 100)); };
    xhr.onload = function () {
      var ok = false;
      if (xhr.status >= 200 && xhr.status < 300) {
        try { var res = JSON.parse(xhr.responseText); if (res.secure_url) { if (propPhotoUrl) propPhotoUrl.value = res.secure_url; uploadComplete = true; showUp('done'); ok = true; } } catch (err) {}
      }
      if (!ok) showUp('error', 'Upload failed \u2014 please try a smaller file or try again.');
      updateAddState();
    };
    xhr.onerror = function () { showUp('error', 'Upload failed \u2014 check your connection and try again.'); updateAddState(); };
    xhr.send(fd);
  }

  function handleFile(file) {
    if (!file) return;
    var isPdf = (file.type === 'application/pdf') || /\.pdf$/i.test(file.name || '');
    var isImage = file.type && file.type.indexOf('image/') === 0;
    if (!isPdf && !isImage) return;

    uploadComplete = false;
    if (propPhotoUrl) propPhotoUrl.value = '';
    updateAddState();

    if (isPdf) {
      img.style.display = 'none';
      empty.style.display = 'flex';
      empty.innerHTML = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg><span><b>PDF received</b><br>No on-screen preview needed \u2014 we print your file exactly as supplied.</span>';
      adjustField.style.display = 'none';
      quality.className = 'pdp-quality';
      uploaded = true;
      uploadBox.innerHTML = '<b>' + (file.name || 'file.pdf').slice(0, 28) + '</b><br><span>PDF \u00b7 click to replace</span>';
      if (propDpi) propDpi.value = 'PDF (print-ready file)';
      uploadToCloud(file);
    } else {
      var r = new FileReader();
      r.onload = function (ev) {
        var im = new Image();
        im.onload = function () {
          imgW = im.naturalWidth; imgH = im.naturalHeight;
          img.src = ev.target.result; img.style.display = 'block'; empty.style.display = 'none';
          adjustField.style.display = 'block';
          uploaded = true;
          uploadBox.innerHTML = '<b>' + file.name.slice(0, 28) + '</b><br><span>' + imgW + ' \u00d7 ' + imgH + 'px \u00b7 click to replace</span>';
          fitImg(); checkQuality(); updateAddState();
        };
        im.src = ev.target.result;
      };
      r.readAsDataURL(file);
      uploadToCloud(file);
    }
  }

  if (fileInput) fileInput.addEventListener('change', function (e) { handleFile(e.target.files[0]); });

  ['dragover', 'dragleave', 'drop'].forEach(function (ev) {
    if (!uploadBox) return;
    uploadBox.addEventListener(ev, function (e) {
      e.preventDefault();
      if (ev === 'drop' && e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
    });
  });

  if (zoom) zoom.addEventListener('input', fitImg);

  var segP = document.getElementById('segPortrait'), segL = document.getElementById('segLandscape');
  if (segP) segP.addEventListener('click', function () { setOrient('portrait'); });
  if (segL) segL.addEventListener('click', function () { setOrient('landscape'); });
  function setOrient(o) {
    orient = o;
    if (segP) segP.classList.toggle('active', o === 'portrait');
    if (segL) segL.classList.toggle('active', o === 'landscape');
    sizePreview();
    if (uploaded) checkQuality();
  }

  function validateCustom() {
    if (!isCustom) return true;
    var w = parseInt(cw.value, 10) || 0, h = parseInt(ch.value, 10) || 0;
    w = Math.min(Math.max(w, 1), 120); h = Math.min(Math.max(h, 1), 120);
    cw.value = w; ch.value = h;
    var mn = Math.min(w, h);
    if (mn > 60) { customValid = false; dimNote.textContent = 'One side must be 60\u2033 or less (max 60\u2033 \u00d7 120\u2033).'; dimNote.classList.add('warn'); }
    else if (w < 5 || h < 5) { customValid = false; dimNote.textContent = 'Minimum 5\u2033 per side.'; dimNote.classList.add('warn'); }
    else { customValid = true; dimNote.textContent = 'Max 60\u2033 \u00d7 120\u2033. Made to order.'; dimNote.classList.remove('warn'); }
    sizePreview(); updateAddState();
    if (uploaded) checkQuality();
    return customValid;
  }
  if (cw) cw.addEventListener('input', validateCustom);
  if (ch) ch.addEventListener('input', validateCustom);

  var chosen = {};
  document.querySelectorAll('.seg-row[data-option]').forEach(function (row) {
    var pos = row.getAttribute('data-option');
    var active = row.querySelector('.seg.active');
    if (active) chosen[pos] = active.getAttribute('data-value');
    row.querySelectorAll('.seg').forEach(function (btn) {
      btn.addEventListener('click', function () {
        row.querySelectorAll('.seg').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        chosen[pos] = btn.getAttribute('data-value');
        resolveVariant();
      });
    });
  });

  function updateRoll() {
    var roll = document.getElementById('pdpRoll');
    if (!roll) return;
    var fr = document.getElementById('formatRow');
    var active = fr ? fr.querySelector('.seg.active') : null;
    roll.style.display = (active && active.getAttribute('data-value') === 'Rolled') ? 'flex' : 'none';
  }

  function resolveVariant() {
    updateRoll();
    var vs = window.PDP_VARIANTS || [];
    var positions = Object.keys(chosen).sort();
    var want = positions.map(function (p) { return chosen[p]; });
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i], match = true;
      for (var j = 0; j < want.length; j++) { if (v.options[j] !== want[j]) { match = false; break; } }
      if (match) {
        if (variantIdInput) variantIdInput.value = v.id;
        var p = '$' + Math.round(v.price / 100);
        if (priceEl) priceEl.textContent = p;
        if (addPriceEl) addPriceEl.textContent = p;
        return;
      }
    }
  }

  function updateAddState() {
    var ok = uploadComplete && (!isCustom || customValid);
    if (addBtn) addBtn.disabled = !ok;
  }

  sizePreview();
  resolveVariant();
  if (isCustom) validateCustom();
  window.addEventListener('resize', function () { if (uploaded) fitImg(); });
})();
